/** "Which airlines and travel sites offer buy now, pay later? (2026 list)": metadata (the article is in ../bodies/airlines-that-offer-buy-now-pay-later.js). */
export default {
  slug: 'airlines-that-offer-buy-now-pay-later',
  category: 'Pay over time',
  title: 'Which airlines and travel sites offer buy now, pay later? (2026 list)',
  seoTitle: 'Airlines That Offer Buy Now, Pay Later (2026 List)',
  description: 'A checked 2026 list of which airlines and travel sites offer Affirm, Flex Pay (Uplift), Klarna or PayPal at checkout, and how Skyscanner and Kayak fit in.',
  dek: 'Every major airline and travel site picks its own pay-later partner, and some pick none. Here is who offers what as of November 2026, checked against the websites of the companies themselves, plus what to do when a search site sends you elsewhere to pay.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'Which US airlines offer buy now, pay later?',
      a: 'As of November 2026, American Airlines offers Affirm, and United, Southwest and Alaska offer Flex Pay by Upgrade, formerly Uplift. JetBlue offers ClarityPay, and Delta accepts PayPal, including PayPal Credit, on flights departing the US.',
    },
    {
      q: 'Can I use buy now, pay later on Skyscanner?',
      a: 'Skyscanner compares fares and sends you to an airline or travel agency to pay, so it has no pay-later plan of its own. Whether you can pay later depends on the site you click through to.',
    },
    {
      q: 'Which online travel agencies offer buy now, pay later for flights?',
      a: 'Affirm names Expedia, Priceline and CheapOair among its leading travel partners, and PayPal says its Pay Later works on Expedia and Booking.com. Alternative Airlines offers Affirm, Klarna, Afterpay, Zip, Sezzle and PayPal to US customers.',
    },
    {
      q: 'Can I book flights with PayPal Pay in 4?',
      a: 'Yes, where the airline or travel site accepts PayPal and you are approved. Pay in 4 covers purchases from $10 to $2,000 in four interest-free payments, and American Airlines, Delta and JetBlue all accept PayPal on their own sites.',
    },
    {
      q: 'Is Uplift the same as Flex Pay?',
      a: 'Yes. Flex Pay is the new name for Uplift, the travel lender owned by Upgrade, so older articles and some bank statements still show the Uplift name.',
    },
    {
      q: 'Is Defera a buy now, pay later lender?',
      a: 'No. Defera is not a lender and runs no credit check. It offers its own layaway-style plan with a deposit and weekly or bi-weekly payments, no interest, and trips that depart at least 22 days after booking.',
    },
  ],
  related: ['book-flights-without-klarna-or-affirm', 'defera-vs-affirm-klarna-uplift', 'semi-private-flights-bnpl'],
};
